import { Box, Chip, Stack } from '@mui/material';
import SafeMarkdown from './SafeMarkdown';
import type { ChatMessage } from './useAskTripsby';

export default function MessageBubble({ message }: { message: ChatMessage }) {
  const mine = message.role === 'user';
  return (
    <Box sx={{ display: 'flex', justifyContent: mine ? 'flex-end' : 'flex-start' }}>
      <Box
        data-role={message.role}
        sx={{
          maxWidth: '92%',
          px: 1.5,
          py: 1,
          borderRadius: 2,
          bgcolor: mine ? 'primary.main' : 'action.hover',
          color: mine ? 'primary.contrastText' : 'text.primary',
        }}
      >
        {mine ? (
          // The host's own words: plain text, never parsed.
          <Box sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', typography: 'body2' }}>{message.content}</Box>
        ) : (
          <SafeMarkdown text={message.content} />
        )}
        {!mine && message.facts && message.facts.length > 0 && (
          <Stack direction="row" flexWrap="wrap" gap={0.5} sx={{ mt: 1 }} aria-label="Key facts">
            {message.facts.map((fact, i) => (
              <Chip key={i} size="small" variant="outlined" label={`${fact.label}: ${fact.value}`} />
            ))}
          </Stack>
        )}
      </Box>
    </Box>
  );
}
